<template>
    <dashboard-layout tit="비대면 면접" topBtn fullHeight>
        <template slot="contents">
            <interview-view mode="view" />
        </template>
    </dashboard-layout>
</template>

<script>
import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import InterviewView from "@/components/dashboard/common/interview/view/interview-view.vue";

export default {
    components: {
        DashboardLayout,
        InterviewView,
    },
};
</script>

<style></style>
